import { createSlice } from "@reduxjs/toolkit";
import {
  clearStoredTeacherAuth,
  clearStoredTeacherSignupContext,
  getStoredTeacherAuth,
  getStoredTeacherSignupContext,
  persistTeacherAuth,
  persistTeacherSignupContext,
} from "./teacherStorage";

const initialAuth = getStoredTeacherAuth();
const initialSignupContext = getStoredTeacherSignupContext();

const initialState = {
  token: initialAuth.token,
  teacher: initialAuth.teacher,
  signupContext: initialSignupContext,
  showLogoutModal: false,
};

const teacherSlice = createSlice({
  name: "teacher",
  initialState,
  reducers: {
    setTeacherSession(state, action) {
      const nextAuth = persistTeacherAuth({
        token: action.payload?.token,
        teacher: action.payload?.teacher,
      });

      state.token = nextAuth.token;
      state.teacher = nextAuth.teacher;
      state.showLogoutModal = false;
    },
    updateTeacherProfile(state, action) {
      const nextTeacher =
        action.payload && typeof action.payload === "object"
          ? { ...(state.teacher || {}), ...action.payload }
          : state.teacher;

      const nextAuth = persistTeacherAuth({
        token: state.token,
        teacher: nextTeacher,
      });

      state.teacher = nextAuth.teacher;
    },
    clearTeacherSession(state) {
      clearStoredTeacherAuth();
      state.token = "";
      state.teacher = null;
      state.showLogoutModal = false;
    },
    expireTeacherSession(state) {
      clearStoredTeacherAuth();
      state.token = "";
      state.teacher = null;
      state.showLogoutModal = true;
    },
    setTeacherLogoutModal(state, action) {
      state.showLogoutModal = Boolean(action.payload);
    },
    setTeacherSignupContext(state, action) {
      const nextContext = persistTeacherSignupContext({
        preAuthToken: action.payload?.preAuthToken,
        email: action.payload?.email,
      });

      state.signupContext = nextContext;
    },
    clearTeacherSignupContext(state) {
      clearStoredTeacherSignupContext();
      state.signupContext = {
        preAuthToken: "",
        email: "",
      };
    },
  },
});

export const {
  setTeacherSession,
  updateTeacherProfile,
  clearTeacherSession,
  expireTeacherSession,
  setTeacherLogoutModal,
  setTeacherSignupContext,
  clearTeacherSignupContext,
} = teacherSlice.actions;

export default teacherSlice.reducer;
